/* eslint-disable no-useless-concat */
import api from "./api";
 


const OperariosRemplazos = {
    
 async listarOperariosRemplazo(datos){
   const config = {
     headers: {
       'Content-Type': 'application/json'
     }
   };
  
  try { // Intentamos realizar la petición al backend
    // Llamada al endpoint que lista asignaciones activas para el rango/datos seleccionados
    return await api.post(`/remplazo/asignaciones`, datos, config); // Devolvemos la respuesta original si es exitosa
  } catch (error: any) { // Capturamos cualquier error HTTP o de red
    // Si el backend responde 404, significa "No hay asignaciones para el rango de fechas" (comportamiento esperado)
    if (error?.response?.status === 404) { // Detectamos específicamente el código 404
      // Normalizamos la salida para la UI devolviendo una estructura compatible con "res.data"
      return { data: [] } as any; // Retornamos una lista vacía para que la interfaz no se rompa
    }
    // Para otros códigos de error, re-lanzamos para que sean tratados más arriba (log, aviso, etc.)
    throw error; // Propagamos el error no controlado (400, 500, etc.)
  }
 },
 
 async vistaRemplazo(datos){
   const config = {
     headers: {
       'Content-Type': 'application/json'
     }
   };
  
   return  api.post(`/remplazo/listar_remplazos`, datos, config)
 },

 async diagnosticoRemplazo(datos){
   const config = {
     headers: {
       'Content-Type': 'application/json'
     }
   };
 
  return api.post(`/remplazo/diagnostico`, datos, config)
 },
 async EliminarVistaRemplazo(datos){
  try{
    const response = await api.post(`/remplazo/eliminar`, datos);
    return response.data;
  }catch(error){
    console.log('[ERROR]:::::',error);
    //ENTRAR EN EL MENSAJE DE ERROR EN LA LLAVE "error" cuando recibe Request failed with status code 400
    return {
      error: error
    }
  }
 },

 async ActuializarRemplazoExistente(datos){
   const config = {
     headers: {
       'Content-Type': 'application/json'
     }
   };
  
   return  api.post(`remplazo/actualizar`, datos, config)
 },
 
 async listarCupo(datos){
   const config = {
     headers: {
       'Content-Type': 'application/json'
     }
   };
  
   return  api.post(`/punto_servicio/cupo_horas_remplazo`, datos, config)
 },

  async listar(filtroNombre?: string) {
    const params = filtroNombre ? `?ps_nombre=${filtroNombre}` : "";
    return api.get(`punto_servicio/todos${params}`);
  },

  async cupoPorDia(datos){
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return api.post(`/punto_servicio/cupo_por_dia`, datos, config)
  },

  async operarioDisponible(datos){
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
   
    return  api.post(`/remplazo/solapa`, datos, config)
  },


  async restarCupo(datos){
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
   
    return  api.post(`/punto_servicio/cupo_restar`, datos, config)
  },

  async sumarCupo(datos){
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
   
    return  api.post(`/punto_servicio/cupo_sumar`, datos, config)
  },

  async cargarRemplazo(datos){
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return  api.post(`/remplazo/crear`, datos, config)
  },

  async checkDias(datos){
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return  api.post(`/remplazo/check_dias`, datos, config)
  },

  async existeDuplicado(datos){
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return api.post(`/remplazo/existe_duplicado`, datos, config)
  },

  async diaLibre(datos){
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return api.post(`/remplazo/dia_libre`, datos, config)
  },


  // --- Compensación V2: integrar con endpoints del backend ---
  async compensacionSaldoOrigen(datos){ // obtener saldo disponible por día en el rango para el reemplazado y PS
    const config = { // configuración de cabeceras HTTP
      headers: { // definición de headers
        'Content-Type': 'application/json' // indicar que el cuerpo es JSON
      }
    };
    return api.post(`/remplazo/compensacion/saldo_origen`, datos, config) // invocar endpoint de saldo de origen
  },

  async compensacionReservar(datos){ // reservar compensación y obtener cupo virtual por fecha destino
    const config = { // configuración de cabeceras HTTP
      headers: { // definición de headers
        'Content-Type': 'application/json' // indicar que el cuerpo es JSON
      }
    };
    return api.post(`/remplazo/compensacion/reservar`, datos, config) // invocar endpoint de reserva lógica
  },

  async compensacionCancelar(datos){ // cancelar una reserva lógica de compensación
    const config = { // configuración de cabeceras HTTP
      headers: { // definición de headers
        'Content-Type': 'application/json' // indicar que el cuerpo es JSON
      }
    };
    return api.post(`/remplazo/compensacion/cancelar`, datos, config) // invocar endpoint de cancelación
  },

  async confirmarRemplazo(confirmacion_id: number){
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    return api.post(`/remplazo/confirmar`, { confirmacion_id }, config)
  },

  async rechazarRemplazo(confirmacion_id: number, motivo: string){ // rechazar asistencia (motivo obligatorio)
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    return api.post(`/remplazo/rechazar`, { confirmacion_id, motivo }, config)
  },

  async listarConfirmaciones(datos: any){ // vista de gestion: reemplazos con su estado de confirmacion
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    return api.post(`/remplazo/confirmaciones/listar`, datos, config)
  },

  async reporteContactPuntos(){ // PS disponibles para el filtro del Reporte de Remplazos Contact
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    return api.post(`/remplazo/reporte-contact/puntos`, {}, config)
  },

  async reporteContactListar(datos: any){ // reporte de reemplazos cargados por el Contact Center
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    return api.post(`/remplazo/reporte-contact/listar`, datos, config)
  },


}



export default OperariosRemplazos;
